<template>
  <div class="content-body">
    <div class="content-inside">
      <b-row>
        <b-col sm="12" md="6" lg="3" class="card card-nav active mt-2">
          <div>
            <b-row>
              <b-col>
                <h6>Sales</h6>
                <i class="ic-tooltip" id="sales-help"></i>
                <b-popover
                  target="sales-help"
                  triggers="hover"
                  content="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                >
                </b-popover>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col sm="6" lg="4">
                <div class="percentage sales">{{ salesRateChangeYear }}</div>
              </b-col>
              <b-col sm="6" lg="8" class="right">
                <b-row>
                  <b-col>
                    <span class="lbl">Lifetime Sales</span>
                    <img
                      src="@/assets/images/peso.svg"
                      alt=""
                      class="peso-ico"
                    />
                    <span class="val">{{ analytics.sales.lifetimeSales }}</span>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col>
                    <span class="lbl">Revenue Sales</span>
                    <img
                      src="@/assets/images/peso.svg"
                      alt=""
                      class="peso-ico"
                    />
                    <span class="val">{{ analytics.sales.revenueSales }}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="hr"><hr /></b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <span class="lbl">Average Order Value</span>
              </b-col>
              <b-col cols="6">
                <p class="val lbl">
                  <img
                    src="@/assets/images/peso.svg"
                    alt=""
                    class="peso-ico"
                  />{{ analytics.sales.averageOrderValue }}
                </p>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="12" md="6" lg="3" class="card card-nav mt-2">
          <div>
            <b-row>
              <b-col>
                <h6>Acquisition</h6>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col sm="6" lg="4">
                <div class="percentage rewards">
                  {{ acquisitionRateChangeYear }}
                </div>
              </b-col>
              <b-col sm="6" lg="8" class="right">
                <b-row>
                  <b-col>
                    <span class="lbl">Registered Users</span>
                    <span class="val">{{
                      analytics.acquisition.registeredUsers
                    }}</span>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col>
                    <span class="lbl">Daily Average</span>
                    <span class="val">{{
                      analytics.acquisition.dailyAverage
                    }}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="hr"><hr /></b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <span class="lbl"
                  >{{ analytics.acquisition.rateChange }}% increase in 30
                  days</span
                >
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="12" md="6" lg="3" class="card card-nav mt-2">
          <div>
            <b-row>
              <b-col>
                <h6>Engagement</h6>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col sm="6" lg="4">
                <div class="percentage engagement">
                  {{ engagementRateChangeYear }}
                </div>
              </b-col>
              <b-col sm="6" lg="8" class="right">
                <b-row>
                  <b-col>
                    <span class="lbl">Lifetime SMS Engagements</span>
                    <span class="val">{{
                      analytics.engagement.lifetimeSms
                    }}</span>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col>
                    <span class="lbl">Daily Average</span>
                    <span class="val">{{
                      analytics.engagement.dailyAverage
                    }}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="hr"><hr /></b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <span class="lbl"
                  >{{ analytics.engagement.rateChange }}% increase in 30
                  days</span
                >
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="12" md="6" lg="3" class="card card-nav mt-2">
          <div>
            <b-row>
              <b-col>
                <h6>Rewards Program</h6>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col sm="6" lg="4">
                <div class="percentage rewards">
                  {{ rewardsRateChangeYear }}
                </div>
              </b-col>
              <b-col sm="6" lg="8" class="right">
                <b-row>
                  <b-col>
                    <span class="lbl">Rewards Redeemed</span>
                    <span class="val">{{ analytics.rewards.redeemed }}</span>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col>
                    <span class="lbl">Issued Rewards</span>
                    <span class="val">{{ analytics.rewards.issued }}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="hr"><hr /></b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <span class="lbl"
                  >{{ analytics.rewards.rateChange }}% increase in 30 days</span
                >
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col sm="6" md="2" class="customers-wrapper mt-1">
          <b-input-group>
            <b-form-select v-model="selectedDays">
              <option value="day" selectedDays>Last 7 days</option>
              <option value="week">last 4 weeks</option>
              <option value="month">last 6 months</option>
            </b-form-select>
          </b-input-group>
        </b-col>
        <b-col sm="6" md="3" class="customers-wrapper mt-1">
          <b-input-group>
            <b-input-group slot="append">
              <i class="icon-calendar"></i>
            </b-input-group>
            <datepicker v-model="anchorDate" :config="daterangeConfig">
            </datepicker>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col lg="12" class="card">
          <div class="no-padding">
            <div class="heading">
              <b-row>
                <b-col md="8">
                  <h6>Sales Overview</h6>
                  <i class="ic-tooltip" id="salesOverview-help"></i>
                  <b-popover
                    target="salesOverview-help"
                    triggers="hover"
                    content="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                  >
                  </b-popover>
                </b-col>
                <b-col md="2" class="customers-wrapper mt-1">
                  <b-input-group>
                    <b-form-select v-model="selectedTransaction">
                      <option :value="null" selectedTransaction>
                        All Transactions
                      </option>
                    </b-form-select>
                  </b-input-group>
                </b-col>
                <b-col md="2" class="customers-wrapper mt-1">
                  <b-input-group>
                    <b-form-select v-model="selectedBranch">
                      <option :value="null" selectedBranch>All Branches</option>
                    </b-form-select>
                  </b-input-group>
                </b-col>
              </b-row>
            </div>
            <div class="chart-wrap">
              <b-row>
                <b-col sm="12" lg="12">
                  <b-row class="total">
                    <b-col sm="12" lg="1" class="mt-3"><h5>Total:</h5></b-col>
                    <b-col md="8" lg="7">
                      <b-row>
                        <b-col>
                          <div class="total-item sales">
                            <h6>Sales</h6>
                            <div class="color">
                              Php {{ analytics.salesOverview.sales }}
                            </div>
                          </div>
                          <div class="total-item revenue">
                            <h6>Revenue</h6>
                            <div class="color">
                              Php {{ analytics.salesOverview.revenue }}
                            </div>
                          </div>
                          <div class="total-item given-points">
                            <h6>Given Points</h6>
                            <div class="color">
                              {{ analytics.salesOverview.givenPoints }} Points
                            </div>
                          </div>
                          <div class="total-item used-points">
                            <h6>Used Points</h6>
                            <div class="color">
                              {{ analytics.salesOverview.usedPoints }} Points
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="12" md="4" lg="4">
                      <div class="legend">
                        <div class="sales">
                          <div class="color"></div>
                          <span>Sales</span>
                        </div>
                        <div class="revenue">
                          <div class="color"></div>
                          <span>Revenue</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div id="app" class="canvas-wrap">
                    <canvas id="planet-chart" style="height: 200px"></canvas>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-4 table-performance">
        <b-col sm="6" lg="6" class="card">
          <div class="no-padding">
            <div class="heading">
              <h6>Branch Performance</h6>
              <i class="ic-tooltip" id="branch-help"></i>
              <b-popover
                target="branch-help"
                triggers="hover"
                content="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
              >
              </b-popover>
            </div>
            <div>
              <b-table
                id="branchItemsTbl"
                :items="analytics.branchItems"
                :per-page="perPage"
                :current-page="currentPage"
                :fields="branchFields"
                responsive
              >
              </b-table>
            </div>
            <div>
              <b-row>
                <b-col>
                  <b-pagination
                    hide-goto-end-buttons
                    align="right"
                    size="md"
                    v-model="currentPage"
                    :total-rows="branchTotalRows"
                    :per-page="perPage"
                    aria-controls="branchItemsTbl"
                    class="custom-pagination"
                  >
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
        <b-col sm="6" lg="6" class="card">
          <div class="no-padding">
            <div class="heading">
              <h6>Rewards Performance</h6>
              <i class="ic-tooltip" id="rewards-help"></i>
              <b-popover
                target="rewards-help"
                triggers="hover"
                content="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
              >
              </b-popover>
            </div>
            <div>
              <b-table
                id="rewardItemsTbl"
                :items="analytics.rewardItems"
                :per-page="rperPage"
                :current-page="rcurrentPage"
                :fields="rewardFields"
                responsive
              >
              </b-table>
            </div>
            <div>
              <b-row>
                <b-col>
                  <b-pagination
                    hide-goto-end-buttons
                    align="right"
                    size="md"
                    v-model="rcurrentPage"
                    :total-rows="rewardTotalRows"
                    :per-page="rperPage"
                    aria-controls="rewardItemsTbl"
                    class="custom-pagination"
                  >
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Datepicker from "vue-bulma-datepicker";
import Chart from "chart.js";
import planetChartData from "@/chart-data.js";
import { mapState } from "vuex";
import moment from "moment";

const branchFields = [
  "bullet",
  "branch",
  "total_sales",
  {
    key: "percent_value",
    formatter: (value) => {
      return value > 0 ? value + "% increase" : 0;
    },
  },
];
const branchItems = [];
const rewardFields = [
  "bullet",
  "badge",
  "total_sales",
  {
    key: "percent_value",
    formatter: (value) => {
      return value > 0 ? value + "% increase" : 0;
    },
  },
];
const rewardItems = [];

export default {
  name: "DashboardTab",
  data() {
    return {
      chart: null,
      labelCount: 0,
      planetChartDataBase: planetChartData,
      planetChartData: null,
      currentPage: 1,
      perPage: 10,
      rcurrentPage: 1,
      rperPage: 10,
      branchFields: branchFields,
      branchItems: branchItems,
      rewardFields: rewardFields,
      rewardItems: rewardItems,
      selectedDays: "day",
      anchorDate: moment().format("YYYY-MM-DD"),
      selectedTransaction: null,
      selectedBranch: null,
      selectedFilter: 0,
      daterangeConfig: {
        altInput: true,
        altFormat: "M j, Y",
        dateFormat: "Y-m-d",
        static: true,
        defaultDate: ["today"],
      },
      branches: null,
    };
  },
  created() {
    this.getAnalyticsA();
    this.getBranchItems();
    this.getRewardItems();
    this.getChartData();
  },
  methods: {
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      ctx.height = 130;
      const myChart = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options,
      });

      return myChart;
    },
    getAnalyticsA() {
      this.$store.dispatch("points/getAnalyticsA", {
        merchant_uuid: this.$store.state.auth.user.merchant_uuid,
      });
    },
    getBranchItems() {
      this.$store.dispatch("points/getBranchItems", {
        merchant_uuid: this.$store.state.auth.user.merchant_uuid,
      });
    },
    getRewardItems() {
      this.$store.dispatch("points/getRewardItems", {
        merchant_uuid: this.$store.state.auth.user.merchant_uuid,
      });
    },
    getChartData() {
      this.$store.dispatch("points/getChartData", {
        merchant_uuid: this.$store.state.auth.user.merchant_uuid,
        selectedDays: this.selectedDays,
        anchorDate: this.anchorDate,
      });
    },
    updateChartData() {
      this.planetChartData = Object.assign(
        this.planetChartDataBase,
        this.analytics.chartData
      );
      this.labelCount = this.planetChartData.data.datasets[0].data.length;
      this.planetChartData.data.datasets[0].backgroundColor = Array(
        this.labelCount
      ).fill("rgba(255, 147, 100, 1)");
      this.planetChartData.data.datasets[1].backgroundColor = Array(
        this.labelCount
      ).fill("rgba(76, 196, 228, 1)");
      if (!this.chart)
        this.chart = this.createChart("planet-chart", this.planetChartData);
      else {
        this.chart.destroy();
        this.chart = this.createChart("planet-chart", this.planetChartData);
      }
    },
    formatRateChangeYear(rate) {
      var rateSymbol = "";

      if (rate < 0) rateSymbol = " \u2193";
      else if (rate > 0) rateSymbol = " \u2191";

      return rate + "%" + rateSymbol;
    },
  },
  watch: {
    "analytics.chartData": function () {
      this.updateChartData();
    },
    selectedDays: function () {
      this.getChartData();
    },
    anchorDate: function () {
      this.getChartData();
    },
  },
  components: {
    Datepicker,
  },
  computed: {
    ...mapState("points", ["analytics"]),
    salesRateChangeYear: function () {
      return this.formatRateChangeYear(this.analytics.sales.rateChangeYear);
    },
    acquisitionRateChangeYear: function () {
      return this.formatRateChangeYear(
        this.analytics.acquisition.rateChangeYear
      );
    },
    engagementRateChangeYear: function () {
      return this.formatRateChangeYear(
        this.analytics.engagement.rateChangeYear
      );
    },
    rewardsRateChangeYear: function () {
      return this.formatRateChangeYear(this.analytics.rewards.rateChangeYear);
    },
    branchTotalRows: function () {
      return this.analytics.branchItems.length;
    },
    rewardTotalRows: function () {
      return this.analytics.rewardItems.length;
    },
  },
};
</script>

<style>
</style>